import { Box, Button, Input, ThemeProvider } from '@mui/material'
import Header from '../../components/Header'

import React from "react"
import { useState } from "react"
import { useTheme } from '@mui/material'

import * as Constants from '../../constants'

const AddWhitelist = () => {
  let theme = useTheme()

  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })
  const [app, setApp] = useState('')

  const handleSubmit = () => {
    fetch(Constants.HOST + '/addWhitelist', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
        app: app,
      }),
    })
      .then((response) => {
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            if (data.success !== true) {
              setError({ error: true, message: data.message})
              setSuccess({ success: false, message: '' })
            } else {
              setError({ error: false, message: '' })
              setSuccess({
                success: true,
                message: data.message
              })
            }
          })
        }
      })
      .catch((error) => {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      })
  }

  return (
    <Box m="20px">
      <Header title="Adicionar app à lista branca" />
      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <ThemeProvider theme={theme}>
        <Box sx={{ flexGrow: 1, display: 'flex' }}>
          <Input
            sx={{ marginRight: '10px', flex: 1, width: '100%' }}
            placeholder="Nome do pacote (com.exemplo.app)"
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setApp(e.target.value)}
          />
          <Button
            variant="outlined, contained"
            sx={{ marginLeft: '10px', bgcolor: 'green' }}
            onClick={handleSubmit}
          >
            Adicionar
          </Button>
        </Box>
      </ThemeProvider>
    </Box>
  )
}

export default AddWhitelist
